module.exports = __webpack_public_path__ + "static/media/RobotoCondensed-Italic.d6fc5ec5.ttf";